export default __webpack_public_path__ + "iconfont.ddf7f1da.eot";